import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TheFooterContacts footer-contacts" }
const _hoisted_2 = { class: "footer-contacts__list" }
const _hoisted_3 = { class: "footer-contacts__list-item" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "footer-contacts__list-item-link-text" }
const _hoisted_6 = { class: "footer-contacts__list-item" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "footer-contacts__list-item-link-text" }
const _hoisted_9 = { class: "footer-contacts__list-item is--last-list-item" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "footer-contacts__list-item-link-text" }
const _hoisted_12 = { class: "footer-contacts__list-item-link-text" }
const _hoisted_13 = { class: "footer-contacts__list-item-link-text" }
const _hoisted_14 = { class: "footer-contacts__list-item-link-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseImage = _resolveComponent("BaseImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: "link-1 footer-contacts__list-item-link",
          href: `mailto:${_ctx.CONTACTS.email}`
        }, [
          _createVNode(_component_BaseImage, {
            class: "footer-contacts__list-item-link-icon",
            src: require(`images/icons/primary-envelope.svg`),
            alt: "envelope icon"
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.CONTACTS.email), 1)
        ], 8, _hoisted_4)
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("a", {
          class: "link-1 footer-contacts__list-item-link",
          href: `tel:${_ctx.CONTACTS.phone}`
        }, [
          _createVNode(_component_BaseImage, {
            class: "footer-contacts__list-item-link-icon",
            src: require(`images/icons/primary-phone.svg`),
            alt: "phone icon"
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.CONTACTS.phone), 1)
        ], 8, _hoisted_7)
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("a", {
          class: "link-1 footer-contacts__list-item-link",
          href: `${_ctx.CONTACTS.mapLink}`,
          target: "_blank",
          rel: "noopener"
        }, [
          _createVNode(_component_BaseImage, {
            class: "footer-contacts__list-item-link-icon",
            src: require(`images/icons/primary-map-marker-alt.svg`),
            alt: "map-marker icon"
          }, null, 8, ["src"]),
          _createElementVNode("span", null, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.CONTACTS.streetAddress) + ", ", 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.CONTACTS.addressLocality) + ",", 1),
            _createElementVNode("span", _hoisted_13, " " + _toDisplayString(_ctx.CONTACTS.addressRegion), 1),
            _createElementVNode("span", _hoisted_14, " " + _toDisplayString(_ctx.CONTACTS.postalCode), 1)
          ])
        ], 8, _hoisted_10)
      ])
    ])
  ]))
}